// Hata raporu tablosunun sütunları (anahtarlar ErrorFeedbacks alanlarıdır).
// Kimlik sütunu (Hata Açıklaması) ve satırdan değiştirilen Durum sabitlenir;
// varsayılan görünürlük eski tablodaki gibidir. Metinler: errorReports.columns.<key>.

export const REPORT_COLUMNS = {
  errorSummary: { type: 'text', width: 340 },
  status: { width: 168 },
  userName: { type: 'text', width: 200 },
  timestamp: { width: 172 },
  screenshotUrl: { width: 150 },
  uid: { type: 'text', width: 250 },
  deviceInfo: { width: 180 },
  browserInfo: { width: 180 },
  errorDetails: { width: 260 },
};

export const COLUMN_KEYS = Object.keys(REPORT_COLUMNS);
export const DEFAULT_VISIBLE_COLUMNS = {
  errorSummary: true,
  status: true,
  userName: true,
  timestamp: true,
  screenshotUrl: true,
  uid: true,
  deviceInfo: false,
  browserInfo: false,
  errorDetails: false,
};
export const MIN_COLUMN_WIDTH = 96;
export const PINNED_COLUMNS = ['errorSummary', 'status'];

/** Columns with a text filter in the header (as the old column searches). */
export const REPORT_FILTER_KEYS = COLUMN_KEYS.filter((key) => REPORT_COLUMNS[key].type === 'text');

/** Stored status values (Turkish, as saved in Firestore) in workflow order. */
export const STATUSES = ['Beklemede', 'İşlemde', 'Tamamlandı', 'İptal'];
export const ALL_STATUSES = 'ALL';

// Placeholders the old page put on reports that lack these fields
export const PLACEHOLDERS = {
  deviceInfo: 'Unknown Device',
  browserInfo: 'Unknown Browser',
  errorDetails: 'No detailed information',
};

// Her süzgeç yazıldığı anda uygulanır (eski sütun aramalarındaki gibi)
export const getFilterState = (key, value) => (value === undefined || value === null || String(value) === '' ? 'off' : 'applied');
